import assert from 'assert-ts';
import dayjs from 'dayjs';
import dayOfYear from 'dayjs/plugin/dayOfYear';

dayjs.extend(dayOfYear);

type MonthRange = {
  startOfMonth: string;
  endOfMonth: string;
};

const startOfMonthFormatted = (date: dayjs.Dayjs): string =>
  date.startOf('month').format('YYYY-MM-DD');

const endOfMonthFormatted = (date: dayjs.Dayjs): string =>
  date.endOf('month').format('YYYY-MM-DD');

export const getDateRangeByFullMonthsFormatted = (
  fromDate: Date | string,
  toDate: Date | string,
): MonthRange[] => {
  assert(
    fromDate <= toDate,
    'getDateRangeByFullMonthsFormatted: Invalid date range, toDate before fromDate',
    {fromDate, toDate},
  );

  let result: MonthRange[] = [];
  let date = dayjs(fromDate);
  const toDateFormatted = endOfMonthFormatted(dayjs(toDate));

  let startOfMonth = startOfMonthFormatted(date);
  let endOfMonth = endOfMonthFormatted(date);
  while (endOfMonth !== toDateFormatted) {
    result.push({startOfMonth, endOfMonth});
    date = date.add(1, 'month');
    startOfMonth = startOfMonthFormatted(date);
    endOfMonth = endOfMonthFormatted(date);
  }

  result.push({startOfMonth, endOfMonth});

  return result;
};
